var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'ChartsUsersPaidTariffs' }}},[_c('doughnut',{attrs:{"title":"Paid Tariffs","apiData":_vm.filteredLatest}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }